<template>
  <main>
    <Trail />
    <Container class="container--main">
      <Title tag="h1">Charlas técnicas</Title>
      <Content :content="content" />
    </Container>
  </main>
</template>
<script>
import programs from "@/data.js";
import Container from "@/components/ui/objects/Container";
import Trail from "@/components/common/Trail";
import Title from "@/components/ui/atoms/Title.vue";
import Content from "@/components/common/Content.vue";
export default {
  components: {
    Container,
    Trail,
    Title,
    Content
  },
  setup() {
    const program = programs[process.env.VUE_APP_PREFIX];
    const content = program.charlas;
    return {
      content
    };
  }
};
</script>
